import RailyOfficerAddRequest from "../../../api/raily/raily-officer/add/raily-officer-add.request";
import RailyOfficerAddParams from "./raily-officer-add-params";

const create = (params: RailyOfficerAddParams): RailyOfficerAddRequest => {
  return {
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    mobilePrimary: params.phoneNumber.number,
    mobilePrimaryPrefix: params.phoneNumber.dialingCode,
    mobileSecondary: params.alternativePhoneNumber.number || null,
    mobileSecondaryPrefix: params.alternativePhoneNumber.dialingCode || null,
    password: params.password,
    username: params.username,
  };
};

const railyOfficerAddParamsFactory = {
  create,
};

export default railyOfficerAddParamsFactory;
